// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReplenishmentInvoiceBreakdownRecordDto
 */
export interface IReplenishmentInvoiceBreakdownRecordDto {
    /**
     * 
     * @type {number}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    invoice_close_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    invoice_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    account_type?: string;
    /**
     * 
     * @type {Date}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    transaction_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    plan_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    disbursement_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    posting_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IReplenishmentInvoiceBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IReplenishmentInvoiceBreakdownRecordDto interface.
 */
export function instanceOfIReplenishmentInvoiceBreakdownRecordDto(value: object): value is IReplenishmentInvoiceBreakdownRecordDto {
    return true;
}

export function IReplenishmentInvoiceBreakdownRecordDtoFromJSON(json: any): IReplenishmentInvoiceBreakdownRecordDto {
    return IReplenishmentInvoiceBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IReplenishmentInvoiceBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReplenishmentInvoiceBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_close_date': json['invoice_close_date'] == null ? undefined : (new Date(json['invoice_close_date'])),
        'invoice_amount': json['invoice_amount'] == null ? undefined : json['invoice_amount'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'transaction_date': json['transaction_date'] == null ? undefined : (new Date(json['transaction_date'])),
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'disbursement_type': json['disbursement_type'] == null ? undefined : json['disbursement_type'],
        'posting_id': json['posting_id'] == null ? undefined : json['posting_id'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IReplenishmentInvoiceBreakdownRecordDtoToJSON(json: any): IReplenishmentInvoiceBreakdownRecordDto {
    return IReplenishmentInvoiceBreakdownRecordDtoToJSONTyped(json, false);
}

export function IReplenishmentInvoiceBreakdownRecordDtoToJSONTyped(value?: IReplenishmentInvoiceBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_close_date': value['invoice_close_date'] == null ? undefined : ((value['invoice_close_date']).toISOString().substring(0,10)),
        'invoice_amount': value['invoice_amount'],
        'plan_name': value['plan_name'],
        'account_type': value['account_type'],
        'transaction_date': value['transaction_date'] == null ? undefined : ((value['transaction_date']).toISOString()),
        'plan_year': value['plan_year'],
        'disbursement_type': value['disbursement_type'],
        'posting_id': value['posting_id'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

